import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { SplashComponent } from './components/splash/splash.component';
import { NgIf } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations'; 
import { AuthenticationService } from './services/authentication.service';
import { ApplicationService } from './services/application.service';
import { PERMISSIONS } from './models/constants';
import { ConfigurationService } from './services/configuration.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, SplashComponent, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1500ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('1500ms ease-out', style({ opacity: 0 })),
      ]),
    ]),
  ],
})

export class AppComponent implements OnInit {
  constructor(private authService:AuthenticationService, private router:Router, private applicationService:ApplicationService, private configurationService:ConfigurationService) {
    if(!this.configurationService.isProdEnvironment()) {
      document.body.classList.add('dev-env'); //ADD DEV BANNER TO UI
    }
  }

  title = 'webapp';
  menuOpen = false;
  userInitials = '';
  showSplash = true;
  isAuthenticated:boolean = false;
  isBusy:boolean = false;
  hasPlayerAdmin:boolean = false;

  async ngOnInit(): Promise<void> {
    if(this.authService.isAuthenticated() && this.authService.loginResult && this.authService.loginResult.player) {
      this.setupAvatar(this.authService.loginResult.player.firstName, this.authService.loginResult.player.lastName);
      this.isAuthenticated = true;
      this.setPermissions();
    }
    this.wireEvents();
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.menuOpen = false;
  }

  async setPermissions() {
    this.hasPlayerAdmin = await this.authService.hasPermission(PERMISSIONS.PLAYERADMIN);
  }

  navigate(path:string):void {
    this.router.navigate([path]);
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }

  logout() {
    this.authService.logout();
  }

  private setupAvatar(firstName:string, lastName:string) {
    let firstInitial = firstName.substring(0,1);
    let secondIntial = lastName.substring(0,1);
    this.userInitials = firstInitial.toUpperCase() + secondIntial.toUpperCase();
  }

  private wireEvents() {
    this.authService.authenticationSubscription.subscribe(action => {
      if(action === "LOGIN") {
        this.isAuthenticated = this.authService.isAuthenticated();
        if(this.authService.loginResult && this.authService.loginResult.player && this.authService.isAuthenticated()) {
          this.setupAvatar(this.authService.loginResult.player.firstName, this.authService.loginResult.player.lastName);
          this.isAuthenticated = true;
          this.setPermissions();
        }
      }
      else if(action === "LOGOUT") {
        this.userInitials = '';
        this.isAuthenticated = false;
        this.router.navigate(['/login']);
      }
    });

    this.applicationService.applicationEventSubscription.subscribe(action => {
      if(action === "SHOWGLOBALSPINNER") {
        this.isBusy = true;
      }
      else if(action === "HIDEGLOBALSPINNER") {
        this.isBusy = false;
      }
    });
  }

  async hasPermission(permission:string):Promise<boolean> {
    return await this.authService.hasPermission(permission);
  }
}
